import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env';

const DEV_PERIMETER_HEADER = 'max-wematch-dev-key';
const DEV_HOSTNAME = 'dev.wematch.team';

const shouldAttachPerimeterHeader = (url: string): boolean => {
  if (environment.production || !environment.perimeterDevKey) return false;

  try {
    const origin =
      typeof window !== 'undefined' ? window.location.origin : 'https://localhost:4200';
    const parsed = new URL(url, origin);
    return parsed.pathname.startsWith('/api/') || parsed.pathname.startsWith('/bff/') || parsed.hostname === DEV_HOSTNAME;
  } catch {
    return url.startsWith('/api/') || url.startsWith('/bff/') || url.includes(DEV_HOSTNAME);
  }
};

export const perimeterDevInterceptor: HttpInterceptorFn = (req, next) => {
  if (!shouldAttachPerimeterHeader(req.url) || req.headers.has(DEV_PERIMETER_HEADER)) {
    return next(req);
  }

  if (typeof window !== 'undefined') {
    console.debug('[WeMatch][perimeter-dev-header]', {
      url: req.url,
      header: DEV_PERIMETER_HEADER,
      applied: true,
    });
  }

  return next(
    req.clone({
      setHeaders: {
        [DEV_PERIMETER_HEADER]: environment.perimeterDevKey,
      },
    }),
  );
};
